'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = {
    template: '<div></div>',
    props: {
        disabled: Boolean,
        readonly: Boolean
    },
    created: function created() {
        this.resolveWidgetOptions();

        this.$on('kendowidgetready', this.ready);
    },
    beforeDestroy: function beforeDestroy() {
        if (this.kendoWidget() && this.kendoWidget().destroy) {
            this.kendoWidget().destroy();
        }
    },
    mounted: function mounted() {
        for (var key in this.$options.propsData) {
            var that = this;

            if (key === 'value') {
                that.$watch(key, function (newValue) {
                    that.changeValue(newValue);
                });
            } else if (key === 'disabled') {
                that.$watch(key, function (newValue) {
                    that.makeDisabled(newValue);
                });
            } else if (key === 'readonly') {
                that.$watch(key, function (newValue) {
                    that.makeReadonly(newValue);
                });
            } else {
                that.$watch(key, function () {
                    that.resolveWidgetOptions();
                    if (that.kendoWidget().setOptions) {
                        that.kendoWidget().setOptions(that.widgetOptions);
                    }
                });
            }
        }
    },

    methods: {
        resolveChildren: function resolveChildren(prop, name) {
            if (!this.widgetOptions[prop] && this.$slots.default) {
                var items = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.$slots.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var childSlot = _step.value;

                        if (childSlot.tag && childSlot.tag.indexOf(name) !== -1) {
                            items.push(childSlot.componentOptions.propsData);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                this.widgetOptions[prop] = items;
            }
        },
        makeDisabled: function makeDisabled(toDisable) {
            if (this.kendoWidget().enable) {
                this.kendoWidget().enable(!toDisable);
            }
        },
        makeReadonly: function makeReadonly(value) {
            if (this.kendoWidget().readonly) {
                this.kendoWidget().readonly(value);
            }
        },
        changeValue: function changeValue(newValue) {
            if (this.kendoWidget().value) {
                this.kendoWidget().value(newValue);
            }
        },
        resolveWidgetOptions: function resolveWidgetOptions() {
            this.widgetOptions = this.parseOptions();
        },
        parseOptions: function parseOptions() {
            var _this = this;

            var options = {};
            for (var key in this.$options.propsData) {
                var propOptions = this.$options.props[key];
                var compositeProps = propOptions.kComposite;

                if (!compositeProps) {
                    options[key] = this.$options.propsData[key];
                } else {
                    this.addCompositeProperty(options, compositeProps.split('.'), this.$props[key]);
                }
            }

            Object.keys(this.$props).forEach(function (event) {
                if (_this.$listeners && _this.$listeners[event.toLowerCase()]) {
                    options[event] = _this.$listeners[event.toLowerCase()];
                }
            });

            return options;
        },
        addCompositeProperty: function addCompositeProperty(obj, keys, val) {
            var lastKey = keys.pop();
            var lastObj = keys.reduce(function (obj, key) {
                obj[key] = _typeof(obj[key]) === 'object' ? obj[key] || {} : {};
                return obj[key];
            }, obj);
            lastObj[lastKey] = val;
        },
        ready: function ready() {
            if (this.$options.propsData.disabled) {
                this.makeDisabled(true);
            }

            if (this.$options.propsData.readonly) {
                this.makeReadonly(true);
            }

            // Clear slots' DOM elements
            kendo.jQuery(this.$el).find('.k-v-delete').remove();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-grid-vue-wrapper/~/@progress/kendo-base-components-vue-wrapper/dist/es/kendo-base-component/index.js
// module id = 479
// module chunks = 45